import type { VoidFunctionComponent } from 'react';

import { isProduction, window } from '../../../globals';
import Card from '../../generic/Card/Card';
import List from '../../generic/List';

import styles from './HeaderWarning.module.less';

export const HeaderWarning: VoidFunctionComponent = () => {
  const userInfo = window.user?.username;
  const orgId = window.user?.organizationId;
  const orgTitle = window.user?.organization?.title;
  const isNotLocal = isProduction;
  let environment = '';
  let color: 'pink' | 'yellow' | 'blue';

  // We don't have a perfect way to differentiate between staging and production, since the global isProduction is true for both.
  // We'll use the hostname to differentiate between the two, which is good enough to use for changing the color of a warning.
  if (isNotLocal && window.location.hostname.includes('staging')) {
    environment = 'Staging';
    color = 'yellow';
  } else if (isNotLocal) {
    environment = 'Production';
    color = 'pink';
  } else {
    environment = 'Local Development';
    color = 'blue';
  }

  return (
    <div className={styles.headerWarning}>
      <Card isFullWidth padding="medium" variant="fill" color={color}>
        <Card.Content>
          <div className={styles.warningTitle}>
            <div>⚠️</div>
            <div>
              Stuff on this page can have catastrophic effects if used incorrectly. Make sure you know what you&#39;re
              doing.
            </div>
            <div>⚠️</div>
          </div>
          <br />
          <span>Do you know:</span>
          <List className={styles.warningList} isBorderless>
            <List.Body>
              <List.Row
                hasTightPadding
                hasTightVerticalPadding
                left={<span>Who you are?</span>}
                right={<b>{userInfo ? `${userInfo}` : ''}</b>}
              />
              <List.Row
                hasTightPadding
                hasTightVerticalPadding
                left={<span>Where you are?</span>}
                right={<b>{orgId && orgTitle ? `${orgId} - ${orgTitle}` : ''}</b>}
              />
              <List.Row
                hasTightPadding
                hasTightVerticalPadding
                left={<span>What environment this is?</span>}
                right={<b>{environment ? `${environment}` : ''}</b>}
              />
            </List.Body>
          </List>
        </Card.Content>
      </Card>
    </div>
  );
};
